import $ from "jquery";
import config from '../../config.json';
import {
  withStyles
} from 'material-ui-next/styles';
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import {
  Redirect
} from 'react-router-dom'
import RaisedButton from 'material-ui/RaisedButton';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import dist_configs from 'zeno-config/dist.json';
import Input, {
  InputLabel
} from 'material-ui-next/Input';
import {
  FormControl,
  FormHelperText
} from 'material-ui-next/Form';
import Select from 'material-ui-next/Select';
import {
  MenuItem
} from 'material-ui-next/Menu';
import UploadIcon from '../../assets/icons/uploadIcon.react.js';
import Button from 'material-ui-next/Button';
import Fade from 'material-ui-next/transitions/Fade';
import {
  LinearProgress
} from 'material-ui-next/Progress';

const create_url = config.server + config.api_path + '/dist/create'

const styles = theme => ({
  progress: {
    minWidth: 300,
    margin: 1 * theme.spacing.unit
  },
  hiddenInput: {
    display: "none"
  },
  icon: {
    marginRight: 1 * theme.spacing.unit
  },
  formButton: {
    marginTop: 2.2 * theme.spacing.unit
  },
  formControl: {
    marginTop: 1 * theme.spacing.unit,
    minWidth: 300,
  },
  fileUpload: {
    marginTop: 2 * theme.spacing.unit,
  }
})

class AddDeviceView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      msg: null,
      redirect: null,
      service: '',
      system: '',
      platform: '',
      version: '',
      level: '0',
      local_file: '',
      uploading: false,
      progress: 0
    }

    this.validatorTypes = {
      service: Joi.string()
        .required()
        .valid(dist_configs.services)
        .label('Package Name'),
      system: Joi.string()
        .required()
        .valid(dist_configs.systems)
        .label('Package System'),
      platform: Joi.string()
        .required()
        .valid(dist_configs.platforms)
        .label('Package Platform'),
      version: Joi.string()
        .required()
        .min(5)
        .max(50)
        .label('Package Version'),
      level: Joi.number()
        .required()
        .integer()
        .min(0)
        .label('API Level'),
      local_file: Joi.object()
        .required()
        .type(File)
        .invalid(['', null])
        .label('Upload File')
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.progress_callback = this.progress_callback.bind(this)

    this.getValidatorData = this.getValidatorData.bind(this)
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'local_file') {
      value = target.files[0]
    }

    this.setState({
      [name]: value
    });
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
        [name]: value
      },
      this.props.handleValidation(name)
    )
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.validate((err) => {
      if (err) {
        return this.setState({
          msg: err.em
        })
      }
      this.setState({
        uploading: true
      }, () => {
        var formData = new FormData()
        formData.append("service", this.state.service)
        formData.append("system", this.state.system)
        formData.append("platform", this.state.platform)
        formData.append("version", this.state.version)
        formData.append("level", parseInt(this.state.level))
        formData.append("local_file", this.state.local_file)
        var self = this;
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: create_url,
            enctype: 'multipart/form-data',
            processData: false, // Important!
            contentType: false,
            cache: false,
            data: formData,
            xhrFields: {
              withCredentials: true
            },
            xhr: function() {
              var myXhr = $.ajaxSettings.xhr();
              if (myXhr.upload) {
                myXhr.upload.onprogress = self.progress_callback
              }
              return myXhr;
            },
          })
          .done((data) => {
            var _err = data.err
            if (_err && _err.ec === 0) {
              this.setState({
                redirect: '/admin/dist/all'
              })
            } else if (_err && _err.ec === 403) {
              this.props.unauthorized()
            } else if (_err) {
              this.setState({
                msg: _err.em
              })
            }
          })
          .always(() => {
            this.setState({
              uploading: false
            })
          })
      })
    })
  }

  progress_callback(e) {
    if (e.lengthComputable) {
      var max = e.total;
      var current = e.loaded;

      const percentage = (current * 100) / max;

      this.setState({
        progress: percentage
      })
    }
  }

  getValidatorData() {
    return this.state
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span>{err_msg}</span>
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    const {
      classes,
    } = this.props
    const {
      uploading,
      progress
    } = this.state
    return (
      <Card>
        <CardHeader
          title="Add New Package"
          subtitle={this.state.msg}
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText>
          <Fade in={uploading}>
            <div className={classes.progress}>
              <LinearProgress variant="determinate" value={progress} />
            </div>
          </Fade>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="service-helper">Service</InputLabel>
            <Select
              value={this.state.service}
              onChange={this.handleChange}
              input={<Input name="service" id="service-helper" onBlur={this.props.handleValidation("service")}/>}
            >
              <MenuItem value="">
                <em>Not Selected</em>
              </MenuItem>
              {dist_configs.services.map((ser) => {
                 return (
                   <MenuItem key={ser} value={ser}>
                     {ser}
                   </MenuItem>
                 )
              })}
            </Select>
            <FormHelperText>{this.renderHelperText(this.props.getValidationMessages('service'))}</FormHelperText>
          </FormControl>
          <br />
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="system-helper">System</InputLabel>
            <Select
              value={this.state.system}
              onChange={this.handleChange}
              input={<Input name="system" id="system-helper" onBlur={this.props.handleValidation("system")}/>}
            >
              <MenuItem value="">
                <em>Not Selected</em>
              </MenuItem>
              {dist_configs.systems.map((ser) => {
                 return (
                   <MenuItem key={ser} value={ser}>
                     {ser}
                   </MenuItem>
                 )
              })}
            </Select>
            <FormHelperText>{this.renderHelperText(this.props.getValidationMessages('system'))}</FormHelperText>
          </FormControl>
          <br />
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="platform-helper">Platform</InputLabel>
            <Select
              value={this.state.platform}
              onChange={this.handleChange}
              input={<Input name="platform" id="platform-helper" onBlur={this.props.handleValidation("platform")}/>}
            >
              <MenuItem value="">
                <em>Not Selected</em>
              </MenuItem>
              {dist_configs.platforms.map((ser) => {
                 return (
                   <MenuItem key={ser} value={ser}>
                     {ser}
                   </MenuItem>
                 )
              })}
            </Select>
            <FormHelperText>{this.renderHelperText(this.props.getValidationMessages('platform'))}</FormHelperText>
          </FormControl>
          <br />
          <FormControl aria-describedby="version" className={classes.formControl}>
            <InputLabel htmlFor="version-helper">Version</InputLabel>
            <Input
              id="version-helper"
              name="version"
              value={this.state.version}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
            />
            <FormHelperText id="version">
              {this.renderHelperText(this.props.getValidationMessages('version'))}
            </FormHelperText>
          </FormControl>
          <br />
          <FormControl aria-describedby="level" className={classes.formControl}>
            <InputLabel htmlFor="level-helper">API level</InputLabel>
            <Input
              id="level-helper"
              name="level"
              value={this.state.level}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
            />
            <FormHelperText id="level">
              {this.renderHelperText(this.props.getValidationMessages('level'))}
            </FormHelperText>
          </FormControl>
          <br />
          <FormControl className={classes.fileUpload} >
            <input
              className={classes.hiddenInput}
              id="icon-button-file"
              name="local_file"
              type="file"
              onChange={this.handleChange}
            />
            <label htmlFor="icon-button-file" >
              <Button
                variant="raised"
                color="primary"
                className={classes.button}
                component="span"
                onBlur={this.props.handleValidation('local_file')}
              >
                <UploadIcon className={classes.icon} />
                {" " + ((this.state.local_file && this.state.local_file.name) || "Upload")}
              </Button>
            </label>
          </FormControl>
          <br />

          <RaisedButton
            className={classes.formButton}
            backgroundColor="#3ed5ad"
            labelColor="#ffffff"
            label={"Add Package"}
            onClick={this.onSubmit}
            disabled={!this.props.isValid()}
          />
        </CardText>
      </Card>
    )
  }
}

export default withStyles(styles)(validation(strategy)(AddDeviceView))



// WEBPACK FOOTER //
// ./src/views/admin/new_dist.react.js